(ns common.schema.entities.counterparty-diligence.project
  (:require
   [common.schema.entities.counterparty-diligence.common :as counterparty-diligence-common]
   [common.schema.entities.counterparty-diligence.templates.registry :as template-registry]
   [common.schema.entities.counterparty-diligence.util :as counterparty-diligence-util]
   [common.schema.schema-utils :as su]))

(def template-options
  (->> template-registry/project-templates
       (mapv (fn [[template-id template]]
               {:key template-id
                :value template-id
                :label (:template/template-name template)}))))

(def schema
  (concat
   (su/text-simple-field :project-counterparty-diligence/project-name
                         "Project name"
                         {:mandatory-config :mandatory/always
                          :system-required? true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :authorization    su/access-user-user})

   (su/text-multiline-field :project-counterparty-diligence/project-description
                            "Project description"
                            {:authorization            su/access-user-user
                             :default-field-visibility :in-use})

   (su/text-simple-field :project-counterparty-diligence/fund-name
                         "Fund name"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})

   (su/single-ref-field :project-counterparty-diligence/source-entity
                        "Source entity"
                        [:entity.type/oppo
                         :entity.type/exit-opportunity]
                        {:authorization            su/access-user-user
                         :default-field-visibility :in-use})

   (su/keyword-field :project-counterparty-diligence/template
                     "Template"
                     template-options
                     {:mandatory-config         :mandatory/always
                      :system-required?         true
                      :system-semantics
                      su/user-provided-system-required-field-semantics
                      :default-field-visibility :in-use-disabled
                      :option-filter-fn         counterparty-diligence-util/template-option-filter})

   counterparty-diligence-common/schema))
